/**
 * Inline skeleton for cargo list rows only (controls remain visible)
 */
export function CargoListSkeleton() {
  return (
    <div className="flex flex-col gap-0.5">
      {/* 5 skeleton rows */}
      {[1, 2, 3, 4, 5].map((i) => (
        <CargoListItemSkeleton key={i} />
      ))}
    </div>
  );
}

/**
 * Single cargo list item skeleton - matches CargoListItem layout, including the
 * phone-only summary line that stands in for the hidden columns.
 */
function CargoListItemSkeleton() {
  return (
    <div className="animate-pulse overflow-hidden rounded-lg border border-gray-200 bg-white px-3 py-2 dark:border-dark-700 dark:bg-dark-800 sm:px-4 sm:py-2.5">
      <div className="flex items-center">
        {/* Charterer Column */}
        <div className="min-w-0 flex-1 pr-2 sm:pr-4">
          <div className="mb-1.5 flex items-center gap-2">
            <div className="h-4 w-32 rounded bg-gray-200 dark:bg-dark-600 sm:h-5" />
            {/* Badge circles */}
            <div className="flex -space-x-2">
              <div className="h-5 w-5 rounded-full bg-gray-200 dark:bg-dark-600" />
              <div className="h-5 w-5 rounded-full bg-gray-200 dark:bg-dark-600" />
            </div>
          </div>
          {/* Phone: summary line. From `sm`: the "Charterer" caption. */}
          <div className="h-3 w-40 rounded bg-gray-200 dark:bg-dark-600 sm:w-16" />
        </div>

        {/* Divider */}
        <div className="hidden h-8 w-px flex-shrink-0 bg-gray-200 dark:bg-dark-600 sm:block" />

        {/* Laycan Column */}
        <div className="hidden flex-1 px-4 sm:block">
          <div className="mb-2 flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200 dark:bg-dark-600" />
            <div className="h-4 w-28 rounded bg-gray-200 dark:bg-dark-600" />
          </div>
          <div className="ml-6 h-3 w-12 rounded bg-gray-200 dark:bg-dark-600" />
        </div>

        {/* Divider */}
        <div className="hidden h-8 w-px flex-shrink-0 bg-gray-200 dark:bg-dark-600 md:block" />

        {/* Cargo Size Column */}
        <div className="hidden flex-1 px-4 md:block">
          <div className="mb-2 flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200 dark:bg-dark-600" />
            <div className="h-4 w-20 rounded bg-gray-200 dark:bg-dark-600" />
          </div>
          <div className="ml-6 h-3 w-16 rounded bg-gray-200 dark:bg-dark-600" />
        </div>

        {/* Divider */}
        <div className="hidden h-8 w-px flex-shrink-0 bg-gray-200 dark:bg-dark-600 lg:block" />

        {/* Trade Route Column */}
        <div className="hidden flex-1 px-4 lg:block">
          <div className="mb-2 flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200 dark:bg-dark-600" />
            <div className="h-4 w-24 rounded bg-gray-200 dark:bg-dark-600" />
          </div>
          <div className="ml-6 h-3 w-20 rounded bg-gray-200 dark:bg-dark-600" />
        </div>

        {/* Divider */}
        <div className="hidden h-8 w-px flex-shrink-0 bg-gray-200 dark:bg-dark-600 xl:block" />

        {/* Primary Broker Column */}
        <div className="hidden flex-1 px-4 xl:block">
          <div className="mb-2 flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200 dark:bg-dark-600" />
            <div className="h-4 w-36 rounded bg-gray-200 dark:bg-dark-600" />
          </div>
          <div className="ml-6 h-3 w-24 rounded bg-gray-200 dark:bg-dark-600" />
        </div>

        {/* Divider */}
        <div className="hidden h-8 w-px flex-shrink-0 bg-gray-200 dark:bg-dark-600 2xl:block" />

        {/* Date/Time Column */}
        <div className="hidden flex-1 pl-4 2xl:block">
          <div className="mb-2 flex items-center gap-2">
            <div className="h-4 w-4 rounded bg-gray-200 dark:bg-dark-600" />
            <div className="h-4 w-24 rounded bg-gray-200 dark:bg-dark-600" />
          </div>
          <div className="ml-6 h-3 w-16 rounded bg-gray-200 dark:bg-dark-600" />
        </div>

        {/* Arrow */}
        <div className="ml-auto flex-shrink-0 pl-2 sm:ml-0 sm:pl-4">
          <div className="h-4 w-4 rounded bg-gray-200 dark:bg-dark-600 sm:h-5 sm:w-5" />
        </div>
      </div>
    </div>
  );
}
